import type { Effect, EffectKind } from '../store/types';

export const effectKinds: EffectKind[] = [
  'none', 'blur', 'glow', 'outline', 'crt', 'chromatic', 'grayscale', 'frostedGlass',
];

/** Default Effect for a given kind. Used by the EffectsPanel dropdown. */
export function defaultEffect(kind: EffectKind): Effect {
  switch (kind) {
    case 'none': return { kind: 'none' };
    case 'blur': return { kind: 'blur', px: 5 };
    case 'grayscale': return { kind: 'grayscale', amt: 0.5 };
    case 'glow': return { kind: 'glow', color: '#ffffff', radius: 12, passes: 2 };
    case 'outline': return { kind: 'outline', color: '#000000', width: 2 };
    case 'crt': return { kind: 'crt', intensity: 0.5 };
    case 'chromatic': return { kind: 'chromatic', offset: 2 };
    case 'frostedGlass': return { kind: 'frostedGlass', blur: 8, tint: 'rgba(255,255,255,0.1)' };
  }
}

/** Pull the user-facing numeric "intensity" out of any Effect for slider UI. */
export function effectIntensity(e: Effect): number {
  switch (e.kind) {
    case 'none': return 0;
    case 'blur': return e.px / 10;       // px in 0..10 → 0..1
    case 'grayscale': return e.amt;
    case 'glow': return e.radius / 16;
    case 'outline': return e.width / 10;
    case 'crt': return e.intensity;
    case 'chromatic': return e.offset / 4;
    case 'frostedGlass': return e.blur / 16;
  }
}

/** Apply a 0..1 intensity to an existing Effect, returning a new Effect of the same kind. */
export function withIntensity(e: Effect, t: number): Effect {
  switch (e.kind) {
    case 'none': return { kind: 'none' };
    case 'blur': return { kind: 'blur', px: t * 10 };
    case 'grayscale': return { kind: 'grayscale', amt: t };
    case 'glow': return { ...e, radius: t * 16 };
    case 'outline': return { ...e, width: t * 10 };
    case 'crt': return { ...e, intensity: t };
    case 'chromatic': return { ...e, offset: t * 4 };
    case 'frostedGlass': return { ...e, blur: t * 16 };
  }
}
